var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 834,
    viewBox: "0 0 552 834",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M546.023 1.46947C548.033 -0.912939 551.893 0.969538 551.253 4.0199L377.596 831.55C377.195 833.463 375.101 834.487 373.345 833.631L1.81237 652.422C0.0560007 651.566 -0.425616 649.285 0.834356 647.791L546.023 1.46947Z",
    fill: "#4d4d4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoid);
export default __webpack_public_path__ + "static/media/boid.c8e84946539eeda91fa829c02186bf58.svg";
export { ForwardRef as ReactComponent };